import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import { Grid, Box, Button } from "@mui/material";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import * as acts from "../../../redux/administrator/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import "./dataHistory.scss";
import { adminRoutes } from "../../../routes/routeConstants";

function Index(props) {
  const navigate = useNavigate();
  const Dispatch = useDispatch();
  // const location = useLocation();
  const dataHistory = useSelector((state) => state?.admin.listHistoryData);
  const [data, setData] = useState([]);

  useEffect(() => {
    Dispatch(acts.listHistoryData(localStorage.batch_id));
    Dispatch(acts.clearApiStatus());
  }, [Dispatch]);

  useEffect(() => {
    if (dataHistory && dataHistory !== data) {
      setData(dataHistory);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataHistory]);

  const handleRedirect = (data) => {
    Dispatch(acts.clearApiStatus());
    Dispatch(acts.clearGetPreviewHistoryData());

    const payload = {
      batchId: localStorage.batch_id,
      objectId: data,
    };
    // navigate("/audit-history", {
    //   state: payload,
    // });
    navigate(`/${adminRoutes.auditHistory}`, {
      state: payload,
    });
  };
  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner data-deletion-wrap">
            <AdministratorHeader text="Time Stamp" isArrow="true" />
            <Grid item md={12}>
              <Box className="project-title"></Box>
              <Box>
                <Grid container spacing={1}>
                  {data?.data?.length === 0 ? (
                    <div className="horizontal-center">
                      <p>No data</p>
                    </div>
                  ) : (
                    data?.data?.map((item, index) => (
                      <Grid
                        className="status-b"
                        item
                        md={2}
                        sm={3}
                        xs={6}
                        key={index}
                        padding={2}
                      >
                        <Button
                          className="btn-top"
                          variant="outlined"
                          onClick={() => handleRedirect(item.obj_id)}
                        >
                          {item.timestamp}
                        </Button>
                      </Grid>
                    ))
                  )}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Index;
